export const settingsRoutes = {
	// require admin permissions
	EDIT_PERMISSION_GROUPS: {
		href: "/permissions/groups/list",
		keywords: ["permission", "groups", "rights"],
		requireAdmin: true,
		label: "Manage Groups and Rights",
	},
	CALCULATE_RIGHTS: {
		href: "/permissions/groups/calculate",
		keywords: ["calculate", "user", "rights"],
		requireAdmin: true,
		label: "Calculate User Rights",
	},
	// require a specific user right
	EDIT_DEFAULT_MATTER_PERMISSIONS: {
		href: "/permissions/defaultMatterPermissions",
		keywords: ["default", "matter", "permissions"],
		requiredRight: "MANAGE_DEFAULT_MATTER_PERMISSIONS",
		label: "Default Matter Permissions",
	},
	// do not require admin permissions
	CHANGE_PASSWORD: {
		href: "/settings/changePassword",
		keywords: ["change", "password"],
		label: "Change Password",
	},
	MY_PROFILE: {
		href: "/settings/MyProfile",
		keywords: [
			"my",
			"profile",
			"user",
			"attributes",
			"display name",
			"email",
		],
		label: "My Profile",
	},
	CONFIGURE_MFA: {
		href: "/settings/configureMFA",
		keywords: [
			"configure",
			"multi factor",
			"multi-factor",
			"mfa",
			"authentication",
		],
		label: "Configure Multi-factor Authentication (MFA)",
	},
	SHARE_PASSWORD_SETTINGS: {
		href: "/settings/sharePasswordSettings",
		keywords: ["share", "password", "external", "protect"],
		label: "External Share Password Protection",
	},
	DOCUMENT_STAMPING: {
		href: "/settings/documentStampSettings",
		keywords: ["document", "stamping"],
		label: "Document Stamping",
	},
	MANDATORY_PROFILING: {
		href: "/settings/mandatoryProfilingSettings",
		keywords: ["mandatory", "profiling", "profile", "metadata"],
		label: "Mandatory Profiling",
	},
	VERSION_CONTROL: {
		href: "/settings/versionControl",
		keywords: ["version"],
		label: "Version Control",
	},
	MANAGE_DOCUMENT_TAGS: {
		href: "/settings/manageDocumentTags",
		keywords: ["document", "tags"],
		label: "Manage Document Tags",
	},
	MANAGE_DOCUMENT_TYPES: {
		href: "/settings/manageDocumentTypes",
		keywords: ["document", "types"],
		label: "Manage Document Types",
	},
	MANAGE_DOCUMENT_STATUSES: {
		href: "/settings/manageDocumentStatuses",
		keywords: ["document", "statuses"],
		label: "Manage Document Statuses",
	},
	MANAGE_CLIENT_TAGS: {
		href: "/settings/manageClientTags",
		keywords: ["client", "tags"],
		label: "Manage Client Tags",
	},
	MANAGE_MATTER_TAGS: {
		href: "/settings/manageMatterTags",
		keywords: ["matter", "tags"],
		label: "Manage Matter Tags",
	},
	MANAGE_MATTER_TYPES: {
		href: "/settings/manageMatterTypes",
		keywords: ["matter", "types"],
		label: "Manage Matter Types",
	},
	MANAGE_OFFICE_BRANCH: {
		href: "/settings/manageOfficeBranch",
		keywords: ["offices", "branches", "locations", "lists"],
		label: "Manage Locations List",
	},
	UPDATE_EXCHANGE_URL: {
		href: "/settings/updateExchangeUrl",
		keywords: ["microsoft", "exchange", "server", "url"],
		label: "Update Microsoft Exchange Server URL",
	},
	GET_OUTLOOK_ADDIN_ADDRESS: {
		href: "/settings/outlookAddinAddress",
		keywords: ["outlook", "add in", "add-in", "addin", "address"],
		label: "Get Outlook Addin Address",
	},
	MANAGE_SMART_FILE_ASSOCIATIONS: {
		href: "/settings/manageSmartFileAssociations",
		keywords: [
			"manage",
			"smart-file",
			"smart file",
			"email",
			"matter",
			"associations",
		],
		label: "Manage Smart-File (Email/Matter) Associations",
	},
	DOWNLOAD_LAUNCHER: {
		href: "/settings",
		keywords: ["launcher", "connector"],
		label: "Download LexWorkplace Launcher",
		action: "downloadLauncher",
	},
	INTEGRATIONS: {
		href: "/settings/integrations",
		keywords: ["integrations", "clio", "litera"],
		label: "Manage Integrations",
	},
};
